import CollapsibleCardExample from "./Example.CollapsibleCard";

export default [
    {
        code: require("!raw-loader!./Example.CollapsibleCard.tsx"),
        component: CollapsibleCardExample,
        stretchContainer: true,
        title: "Collapsible Card"
    }
];
